var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.monthlyPaidProduct && _vm.annualPaidProduct
    ? _c(
        "b-tabs",
        {
          staticClass: "justify-content-center cadence-tabs mt-3 mb-2 nav-fill",
          attrs: { pills: "" }
        },
        [
          _c("b-tab", {
            attrs: {
              active: _vm.activeTab === _vm.annualPaidProduct.productId,
              "data-test-hook": "subscription-cadence-tabs-annual"
            },
            on: {
              click: function($event) {
                return _vm.$emit("setSelectedProduct", _vm.annualPaidProduct)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function() {
                    return [
                      _vm.activeTab === _vm.annualPaidProduct.productId
                        ? _c("i", { staticClass: "fa-solid fa-check mr-1" })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(_vm.$t("xBilledAnnually")) + " ")
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2197581990
            )
          }),
          _c("b-tab", {
            attrs: {
              active: _vm.activeTab === _vm.monthlyPaidProduct.productId,
              "data-test-hook": "subscription-cadence-tabs-monthly"
            },
            on: {
              click: function($event) {
                return _vm.$emit("setSelectedProduct", _vm.monthlyPaidProduct)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function() {
                    return [
                      _vm.activeTab === _vm.monthlyPaidProduct.productId
                        ? _c("i", { staticClass: "fa-solid fa-check mr-1" })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(_vm.$t("xBilledMonthly")) + " ")
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2075051859
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }